import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Button, useTheme } from "@mui/material";
import { FC, useRef } from "react";
import { useLocalization } from "../../../hooks/useLocalization";

interface CsvImportButtonProps {
  onFileSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CsvImportButton: FC<CsvImportButtonProps> = ({ onFileSelect }) => {
  const { t } = useLocalization();
  const theme = useTheme();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    // Reset the input value before opening file dialog to allow selecting the same file again
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    fileInputRef.current?.click();
  };

  return (
    <>
      <input
        accept=".csv,text/csv"
        onChange={onFileSelect}
        ref={fileInputRef}
        style={{ display: "none" }}
        type="file"
      />
      <Button
        fullWidth
        onClick={handleClick}
        startIcon={<UploadFileIcon />}
        sx={{ color: theme.colors.primary[5], height: 40 }}
        variant="secondary"
      >
        {t("licenses.addToWhitelistDialog.importCsv")}
      </Button>
    </>
  );
};
